import { render } from "./YellowCompanyRegistration.vue?vue&type=template&id=5976429b"
import script from "./YellowCompanyRegistration.vue?vue&type=script&lang=js"
export * from "./YellowCompanyRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__